import { render, staticRenderFns } from "./OverviewExportMenu.vue?vue&type=template&id=15dca7f2"
import script from "./OverviewExportMenu.vue?vue&type=script&lang=js"
export * from "./OverviewExportMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports